<script lang="ts" setup>
import { computed } from 'vue';
import { type RouteLocationRaw, RouterLink } from 'vue-router';

const props = defineProps<{
  link: string | RouteLocationRaw;
  target?: string;
}>();

const isExternal = computed(() => typeof props.link !== 'string');
</script>

<template>
  <RouterLink v-slot="{ href, isExactActive, navigate }" custom :to="link">
    <li
      class="group/breadcrumb-item hidden min-w-0 max-w-full last:flex after:not-last:flex after:not-last:items-center after:not-last:text-grey-200 after:not-last:content-['/'] @sm/breadcrumb:[&:nth-last-child(-n+2)]:flex @lg/breadcrumb:[&:nth-last-child(-n+3)]:flex"
      :class="{ 'pointer-events-none cursor-default': isExactActive }"
    >
      <Component
        :aria-current="isExactActive ? 'page' : undefined"
        class="flex min-w-0 items-center text-primary-900 hover:no-underline group-last/breadcrumb-item:font-bold group-last/breadcrumb-item:text-primary @sm/breadcrumb:group-[:last-child:not(:first-child)]/breadcrumb-item:pl-2 @sm/breadcrumb:group-[:nth-last-child(2)]/breadcrumb-item:pr-2 @lg/breadcrumb:group-[:nth-last-child(2):not(:first-child)]/breadcrumb-item:pl-2 @lg/breadcrumb:group-[:nth-last-child(3)]/breadcrumb-item:pr-2"
        :href="props.link ? (isExternal ? href : (props.link as string)) : undefined"
        :is="props.link ? 'a' : 'span'"
        :target="props.link ? props.target : undefined"
        @[isExternal&&`click`]="navigate"
      >
        <span class="truncate">
          <slot></slot>
        </span>
      </Component>
    </li>
  </RouterLink>
</template>
